import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Inject, Input } from '@angular/core';

@Component({
  selector: 'oir-copy-to-clipboard',
  template: '<span class="clipboard" [class.disabled]="disabled" (click)="copyToClipboard()">{{ "GENERAL.COPYTOCLIPBOARD" | translate }}</span>',
  styleUrls: ['./copy-to-clipboard.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CopyToClipboardComponent {
  @Input('disabled') disabled = false;
  @Input('target') target: string;

  private dom: Document;

  constructor(@Inject(DOCUMENT) dom: any, private el: ElementRef) {
    this.dom = dom;
  }

  public copyToClipboard(): void {
    const tmpElement = this.dom.createElement('textarea');

    this.dom.body.getElementsByClassName('body')[0].appendChild(tmpElement);

    try {
      const target = this.dom.getElementById(this.target);
      const value = target['innerText'] || target['value'] || '';

      tmpElement.value = value;
      tmpElement.innerText = value;
      tmpElement.select();

      this.dom.execCommand('copy');
      this.el.nativeElement.focus();
    } finally {
      this.dom.body.getElementsByClassName('body')[0].removeChild(tmpElement);
    }
  }
}
